const actions = {
    GET_BULK_QR_REPORT: 'GET_BULK_QR_REPORT',
    GET_BULK_QR_REPORT_SUCCESS: 'GET_BULK_QR_REPORT_SUCCESS',
    GET_BULK_QR_REPORT_FAILED: 'GET_BULK_QR_REPORT_FAILED',

    GET_BULK_QR_DETAILS: 'GET_BULK_QR_DETAILS',
    GET_BULK_QR_DETAILS_SUCCESS: 'GET_BULK_QR_DETAILS_SUCCESS',
    GET_BULK_QR_DETAILS_FAILED: 'GET_BULK_QR_DETAILS_FAILED',

    RESET_MESSAGE: 'RESET_MESSAGE',
    RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',

    getBulkQrReport: (data) => ({
        type: actions.GET_BULK_QR_REPORT,
        payload: { data },
    }),
    getBulkQrReportSuccess: (data) => ({
        type: actions.GET_BULK_QR_REPORT_SUCCESS,
        payload: data,
    }),
    getBulkQrReportFailed: (error) => ({
        type: actions.GET_BULK_QR_REPORT_FAILED,
        payload: error,
    }),

    getBulkQrDetails: (data) => ({
        type: actions.GET_BULK_QR_DETAILS,
        payload: { data },
    }),
    getBulkQrDetailsSuccess: (data) => ({
        type: actions.GET_BULK_QR_DETAILS_SUCCESS,
        payload: data,
    }),
    getBulkQrDetailsFailed: (error) => ({
        type: actions.GET_BULK_QR_DETAILS_FAILED,
        payload: error,
    }),
    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),
    resetSucessMessage: () => ({
        type: actions.RESET_SUCCESS_MESSAGE,
    }),
};
export default actions;